import React, { FC } from 'react'
import { IconComponent, UITypes } from 'LibNeo'
import {
	InterfaceElementModel,
	interfaceElementSlice,
	interfaceElementsSelector,
} from 'Pages/interfaceElement'
import { useAppDispatch } from 'Src/hooks'
import { useSelector } from 'react-redux'

interface ComponentProps {
	item: InterfaceElementModel
}

const actions = {
	setExpandId: interfaceElementSlice.actions.setExpandId,
}

export const CustomColumnExpand: FC<ComponentProps> = ({ item }) => {
	const { setExpandId } = useAppDispatch(actions)
	const expandId = useSelector(interfaceElementsSelector.getExpandId)
	const onSetExpand = () =>
		setExpandId({
			id: expandId === item.id ? null : item.id,
			item: expandId === item.id ? null : item,
		})
	return (
		<>
			{item?.children?.length > 0 ? (
				<IconComponent
					name={expandId === item?.id ? 'minus' : 'plus'}
					type={UITypes.GREY}
					onClick={onSetExpand}
				/>
			) : (
				''
			)}
		</>
	)
}
